
import { FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import CheckBoxWidget from "common/form/widgets/CheckBoxWidget";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import TextWidget from "common/form/widgets/TextWidget";
import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import { ILinkType, IStaticLinkData, LinkTypeRegistry } from "../ILinkType";

interface IStaticLink extends IStaticLinkData {
	href: string;
	newTab: boolean;
}

const staticLink: ILinkType<IStaticLink> = {
	type: "static",
	label: "Static/External Link",
	icon: IconNames.LINK,
	renderInput: (value: IStaticLink, onChange: (value: IStaticLink) => void) => (
		<React.Fragment>
			<FormGroup label="Label">
				<TextWidget onChange={(label) => onChange({...value, label})} value={value.label} />
			</FormGroup>
			<FormGroup label="Link">
				<TextWidget onChange={(href) => onChange({...value, href})} value={value.href} />
			</FormGroup>
			<FormGroup label="Open in New Tab?">
				<CheckBoxWidget onChange={(newTab) => onChange({...value, newTab})} value={value.newTab} />
			</FormGroup>
			<FormGroup label="Icon">
				<TextWidget onChange={(icon) => onChange({...value, icon})} value={value.icon} />
			</FormGroup>
			<FormGroup label="Icon Type">
				<ButtonSelect
					onChange={(iconType: "bp" | "external") => onChange({...value, iconType})}
					options={[
						{value: "bp", label: "Blueprint"},
						{value: "external", label: "External"}
					]}
					value={value.iconType || "bp"}
				/>
			</FormGroup>
		</React.Fragment>
	),
	mapDataToMenuNode: (data: IStaticLink, {children, id}) => {

		return {
			id,
			data,
			children,
			label: <Label k={`link.${id}`} v={data.label} />,
			icon: <Icon icon={data.icon} type={data.iconType} />
		};
	},
	doNavigate: (data) => {
		if (data.href) {
			window.open(data.href, data.newTab ? '_blank' : '_self');
		}
	}
};

export default LinkTypeRegistry.registerType(staticLink);



// WEBPACK FOOTER //
// ./src/common/views/menuTree/linkTypes/StaticLink.tsx